<template>
    <div class="login-body">
        <div class="login-image"></div>
        <div class="card login-panel p-fluid">
            <div class="login-panel-content">
                <div class="flex justify-content-between flex-wrap">
                    <div class="col-3">
                        <img src="/assets/layout/images/login/icon-login.svg" height="64" alt="avalon-vue"/>
                    </div>
                    <div class="col-9 flex flex-column justify-content-around">
                        <h2 class="welcome-text">Welcome!</h2>
                        <span>Sign in to {{ cabinetName }}</span>
                    </div>
                    
                    <form @submit.prevent="signin" class="col-12 p-fluid formgrid grid">
                        <div class="field col-12 text-left">
                            <label for="email">E-mail</label>
                            <InputText
                                id="email"
                                v-model="v$.form.email.$model"
                                :class="{ 'p-invalid': v$.form.email.$error }"
                                placeholder="E-mail"
                            />
                            <div class="error" v-if="v$.form.email.$error">
                                <span v-if="v$.form.email.required.$invalid">Field is required</span>
                                <span v-else-if="v$.form.email.email.$invalid">Please enter a valid email</span>
                            </div>
                        </div>

                        <div class="field col-12 text-left">
                            <label for="password">Password</label>
                            <InputText
                                id="password"
                                v-model="v$.form.password.$model"
                                :class="{ 'p-invalid': v$.form.password.$error }"
                                type="password"
                                placeholder="Password"
                            />
                            <div class="error" v-if="v$.form.password.$error">
                                <span v-if="v$.form.password.required.$invalid">Field is required</span>
                                <span v-else-if="v$.form.password.minLength.$invalid">Password must be at least 6 characters</span>
                            </div>

                            <div class="error" v-if="authError">
                                {{ authError }}
                            </div>
                        </div>

                        <div class="field col-12 text-left">
                            <Button 
                                id="signin-button" 
                                label="Sign In" 
                                type="submit"
                                :disabled="v$.form.$invalid || loading"
                            />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required, email } from '@vuelidate/validators';
import UserService from '../service/UserService';
import cookies from 'vue-cookies';

export default {
    setup() {
        return { v$: useVuelidate() }
    },
    data() {
        return {
            form: {
                email: '',
                password: ''
            },
            loading: false,
            authError: null
        };
    },
    computed: {
        cabinetName() {
            if (window.application === 'cabinet') {
                return 'Cabinet';
            } else if (window.application === 'backoffice') {
                return 'Cabinet';
            }
            throw new Error('Invalid application');
        }
    },
    validations() {
        return {
            form: {
                email: { 
                    required,
                    email
                },
                password: {
                    required
                }
            }
        };
    },
    userService: null,
    created() {
        this.userService = new UserService();
    },
    methods: {
        async signin() {
            const isFormCorrect = await this.v$.$validate();
            if (!isFormCorrect) {
                return;
            }
            this.loading = true;
            this.authError = null;

            try {
                const response = await this.userService.authorize(this.form.email, this.form.password);

                if (response.status === 200) {
                    const userData = response.data.model;

                    localStorage.setItem('user', JSON.stringify(userData));
                    cookies.set('jwt', JSON.stringify(userData));

                    window.location.replace('/sport-programs');
                }
            } catch (error) {
                if (error.response?.status === 401) {
                    this.authError = 'Invalid email or password';
                } else {
                    this.authError = 'An error occurred. Please try again.';
                }
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>

<style scoped>

</style>
